import Confirm from './confirm/ConfirmEmail';
import ResendConfirm from './resend/ResendConfirmEmail';
import Source from './source/ConfirmEmailSource';
import SetupPassword from './setup-password/ConfirmEmailSetupPassword'

export default { Confirm, ResendConfirm, Source, SetupPassword };
